import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import { sanitizeConfigOptions } from "@labxchange/util-sanitization";
/**
 * The label Components for Question Options.
 */
export function Label(props) {
  return (
    <label htmlFor={props.id} className={props.className}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <div>
        <FormattedMessage
          id="formatted-message"
          string={props.label}
          sanitizeConfig={sanitizeConfigOptions.BlockText}
          description=""
        />
      </div>
    </label>
  );
}
Label.propTypes = {
  /**
   * className to be set for label element
   */
  className: PropTypes.string,
  /**
   * Text to be displayed
   */
  label: PropTypes.string.isRequired,
  /**
   * id for label (should match the id of the associated form control)
   */
  id: PropTypes.string.isRequired,
};

Label.defaultProps = {
  className: "",
  label: "",
};

export default Label;
